var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "163.793 41.379 172.414 277.813",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(8, 20, 255)"
    },
    cx: 250,
    cy: 73.379,
    rx: 32,
    ry: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(255, 255, 255)"
    },
    x: 163.8,
    y: 123.79,
    width: 172.4,
    height: 195.402,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 173.793 121.264 L 326.207 121.264 C 331.73 121.264 336.207 125.741 336.207 131.264 L 336.207 244.516 L 267.069 197.43 C 258.196 191.387 249.142 191.369 239.906 197.375 L 163.793 246.877 L 163.793 131.264 C 163.793 125.741 168.27 121.264 173.793 121.264 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(0, 255, 13)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed9db8fcf996b12a3b68d5ecdeea27d6.svg";
export { ForwardRef as ReactComponent };